import { authApi } from '../api/authApi'
import type { ApiError } from '@/types/api'
import type { LoginData } from '../schema/loginSchema'

export const login = async (data: LoginData) => {
  try {
    const response = await authApi.login(data)
    return response.data
  } catch (err) {
    const error = err as ApiError
    throw error
  }
}
